export default __webpack_public_path__ + "static/media/image4.364ec228.png";